<div class="hidewhenloading details-container" #hidewhenloading>  
  <div *ngIf="this.moduleCompleted" class="d-block align-items-end justify-content-end mb-2 completed-badge">
    <!-- Progress bar 1 -->
    <div class="progress  mx-auto mb-0" [ngClass]="passed? '' :'progress-color'" [attr.data-value]='scorePercentage' >
      <span class="progress-left">
        <span class="progress-bar" [ngClass]="passed? 'border-primary' :'border-failed'" ></span>
      </span>
      <span class="progress-right">
        <span class="progress-bar" [ngClass]="passed? 'border-primary' :'border-failed'" ></span>
      </span>
      <div class="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center pt-2">
        <div class="h2 font-weight-bold">{{scorePercentage}}%</div>

      </div>
    </div>
    <div class="h2 font-weight-bold text-center">{{passed? "PASSED":"FAILED"}}</div>

    <!-- END -->  </div>
  <div class="d-flex flex-column flex-md-row justify-content-center">
    <div class="module-overview mw-100 mx-auto ml-lg-0 mr-md-5">
      <img src="{{modulelogourl}}" alt="Banner image for {{this.headerinfo.headerDisplay.maintitle}}"
        class="w-100 bg-black-100 object-cover object-center mb-3 rounded shadow-sm-darker">
      <div id="coursedescription" [innerHTML]="moduledescription" class="innerHTML-wrap"></div>

    </div>
    <div *ngIf="(!this.school.hideFeesForFreeCourses || moduleInfo.price) && !currentUserIsStudent"
      class="module-pricing-aside text-center flex-shrink-0 mx-auto mx-lg-0">
      <section class="mt-5 mt-lg-0">
        <h3 class="mb-0">Course Price</h3>
        <p class="mb-0 font-weight-600">
          <span class="text-2xl2 text-gradient-primary">{{moduleInfo.price ? ('₦' + this.formatNumber(moduleInfo.price))
            : 'Free'}}</span>
          <br>
          For
          <br>
          <span id="moduleaccessdays" class="text-2xl2 text-gradient-primary">{{moduleInfo.accessdays ||
            'Unlimited'}}</span>
          <br>
          Day{{moduleInfo.accessDays !== 1 ? 's' : ''}} Access
        </p>
      </section>
      <section class="mt-5" *ngIf="modulePackageNames.length > 0">
        <h3 class="mb-4">This course is part of package(s): </h3>
        <div class="list-group list-group-flush rounded-md shadow-sm-darker overflow-hidden">
          <a *ngFor="let modulePackageName of modulePackageNames" routerLink="/user/packagedetails"
            [queryParams]="{ 'packageId': modulePackageName.id}"
            class="list-group-item list-group-item-action text-sm text-primary-darker">{{modulePackageName.name}}</a>
        </div>
        <!-- <ng-template #noPackage>
          <p class="text-sm font-italic mb-0">None</p>
        </ng-template> -->
      </section>
    </div>
  </div>
  <div class="d-flex justify-content-center mt-2">
    <p class=" m-1" *ngIf="moduleInfo.nextBatchDate"><b>Next Batch Starts:
      </b>{{this.util.formatDate(moduleInfo.nextBatchDate)}}</p>
    <p class=" m-1 text-warning" *ngIf="!moduleInfo.nextBatchDate && moduleInfo.allowBatches && currentUserIsAdmin"><i
        class="fa fa-info-circle"> </i> Users will not be able to enroll until a new batch has been created</p>

  </div>
  <section id="moduletutors d-flex justify-content-center" class=" mt-2">

    <div class="row justify-content-center ">
      <div class="col-md-3">
        <div class="p-2 bd-highlight">
          <h3 class="text-center">Meet Your Tutors</h3>
          <p *ngIf="tutorList.length === 0" class="text-center text-sm font-italic mb-0">No Tutor Has Been Added</p>
          <div>
            <app-adminusers [school]=true [tutorList]="tutorList" [moduledisplay]=true
              [showbuttons]=false></app-adminusers>
          </div>
        </div>
      </div>
      
      <div class="col-md-3">
        <div class="p-2 bd-highlight">
          <div class="course-forum-link-div">
            <a *ngIf="currentUserIsAdmin || currentUserIsStudent" routerLink="/user/forum"
              [queryParams]="{ 'moduleid': this.moduleInfo.id }">
              <h2 class="text-link font-weight-bold text-center"> Go To Course Forum</h2>
            </a>
          </div>
        </div>
      </div>
      
      <div class="col-md-3">
        <div class="p-2 bd-highlight" >
          <!-- Progress bar 1 -->
          <div *ngIf="currentUserIsStudent" class="progress mx-auto mb-0" [attr.data-value]='progress'>
            <span class="progress-left">
              <span class="progress-bar border-primary"></span>
            </span>
            <span class="progress-right">
              <span class="progress-bar border-primary"></span>
            </span>
            <div class="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center pt-2">
              <div class="h2 font-weight-bold">{{progress}}%</div>
  
            </div>
          </div>
          <div  *ngIf="currentUserIsStudent" class="h2 font-weight-bold text-center">completed</div>
  
          <!-- END -->
        </div>
      </div>
    </div>

    <button *ngIf="moduleInfo.requireEnrollment && !currentUserIsAdmin && !currentUserIsStudent && !notauser"
      [disabled]="!moduleInfo.nextBatchDate && moduleInfo.allowBatches" (click)="submtEnroll()"
      class="btn mx-auto mb-4">{{enrollText}}</button>
    <a *ngIf="!useraccessservice.loggedIn()"
       [routerLink]="['/access/register']"
       [queryParams]="{ goto: '/user/moduledetails?moduleID=' + moduleInfo.id }"
       class="mt-2"
      >
      <button class="btn btn-primary">
        Enroll now
      </button>
    </a> 
    
    <div class="d-flex justify-content-center">

      <div class="ml-3 mt-4">
        <button *ngIf="this.courseEvent.length > 0 && currentUserIsStudent" (click)="gotoUpcomingEvents()" class="btn">
          <i class="fas fa-eye"></i>
          View Course Events</button>
      </div>

    </div>

  </section>

  <app-milestone 
    [activateLessonDeadlineNotification]="moduleInfo.activateLessonDeadlineNotification"
    [lessons]="lessons"
    [enrolledDate]="enrolledDate"
    *ngIf="lessons?.length > 1 && !currentUserIsAdmin">
  </app-milestone>
  
  <section id="modulecurri" class="curriculum mx-auto mt-2">
    <h3 class="mb-3 text-center">Course Curriculum</h3>

    <div *ngIf="(!lessons || lessons.length === 0) && currentUserIsAdmin" class="bg-white p-4 rounded shadow-sm-darker">
      <button routerLink='/user/editlesson' [queryParams]="lessonurlparam" class="btn"><i class="fa fa-plus"></i> Create
        Your First Lesson </button>
    </div>
    <app-classlist [lessons]="lessons" [admin]=currentUserIsAdmin (remove)="reloadlesson($event)"
      [canViewLessons]="canViewLessons" (successmessage)="displaysucessmsg($event)"
      (errormessage)="errormessage($event)"></app-classlist>
  </section>
  <section *ngIf="this.showCompleteButton && !this.moduleCompleted && this.currentUserIsStudent">
    <button class="btn mt-4" [disabled]="!this.enableCompleteButton" (click)="markCourseComplete()">Complete
      Course</button>
  </section>
</div>

<div class="modal fade" id="deleteCourse" data-keyboard="false" data-backdrop="static" aria-hidden="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Delete Course</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <p class="text-center pb-2">Are you sure you want to delete this course?</p>
        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="submit" class="btn btn--danger m-0" (click)="deleteModule()">Delete</button>
          <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="modal fade" id="paymentDialog" data-keyboard="false" data-backdrop="static" aria-hidden="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <iframe sandbox="allow-scripts allow-forms allow-modals allow-popups allow-same-origin" #paymentIframe class="payment-iframe"></iframe>
      </div>
    </div>
  </div>
</div> -->

<div class="modal fade" #enrolstudents id="enrolstudents" aria-hidden="true" aria-labelledby="enrolstudents"
  role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Enrol Students for Course</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p *ngIf="!allowBatches"><a href="../../assets/templates/CourseStudentEnrollTemplate.xlsx"
            class="text-link text-xs"><i class="fa fa-info-circle"></i> Download Template</a></p>
        <p *ngIf="allowBatches"><a href="../../assets/templates/CourseStudentEnrollTemplateBatched.xlsx"
            class="text-link text-xs"><i class="fa fa-info-circle"></i> Download Template</a></p>
        <form #uploadform="ngForm" (ngSubmit)="enrolstudent(files.files)" name="uploadform">
          <p class="text-center text-sm">{{enrolFileName || 'No File Selected'}}</p>
          <button (click)="files.click()" type="button" id="filesLabel" class="btn m-auto">Select
            File</button>
          <input #files (change)="enrolFileName = files.files[0]?.name" type="file" name="files" accept=".xls,.xlsx"
            aria-labelledby="filesLabel" id="classfile" class="sr-only" required>
          <div class="d-flex justify-content-around flex-wrap gap-1.5 mt-5">
            <button type="submit" class="btn m-0" [disabled]="files.files.length < 1">Upload</button>
            <button type="button" class="btn btn--warning m-0" (click)="closeEnrolModal()">Close</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="upcomingEventModal" data-keyboard="false" data-backdrop="static" aria-hidden="true"
  role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Upcoming Event</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <div class="table-responsive">
          <table class="table align-items-center table-flush table-hover">
            <!-- <thead>
                    <tr>
                        <th colspan="4" class="text-right"> Total : </th><th class="text-right">₦{{this.util.numberWithCommas(sumTotal)}}</th>
                    </tr>
                </thead> -->
            <thead class="thead-light">
              <tr>
                <th> Subject </th>
                <th class="text-center"> Status </th>
                <th class="text-center"> Start Date</th>
                <th> End Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of courseEvent">
                <td>{{item.subject}}</td>
                <td
                  [ngClass]="{ 'bg-red': item.isCancelled, 'bg-green': !item.isCancelled && !isExpierd(item),'bg-yellow': !item.isCancelled && isExpierd(item) }">
                  {{ item.isCancelled ?
                  'Cancelled' : isExpierd(item)? 'Expired':'Active'}}</td>
                <td class="text-center">{{this.util.formatDate(item.inviteStartDate)}}</td>
                <td>{{this.util.formatDate(item.inviteEndDate)}}</td>
              </tr>
            </tbody>
          </table>
          <p *ngIf="courseEvent.length<=0" class="text-center">No Available event</p>
          <div class="d-flex justify-content-center flex-wrap gap-1.5">
            <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="popbatch" data-keyboard="false" data-backdrop="static" aria-hidden="true" role="dialog">
  <div class="modal-dialog" style="    max-width: max-content !important;">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Select Batch</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <div class="d-flex justify-content-center mb-3">
          <select class="form-control" [(ngModel)]="selectedBatchId" [ngModelOptions]="{standalone: true}">
            <option selected disabled value="0">Select Batch</option>           
            <option *ngFor="let item of moduleBatches" [ngValue]="item.id">
              {{ item.name }} | Start Date: {{ util.formatDate(item.startDate) }}
            </option>
          </select>
        </div>

        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="submit" class="btn btn--primary m-0" (click)="enroll()">Submit</button>
          <button type="button" class="btn btn--warning m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" #scromupload id="scromupload" aria-hidden="true" aria-labelledby="scromupload" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Upload Scrom File (v1.2)</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form #uploadform="ngForm" (ngSubmit)="uploadScrom(Scormfiles.files)" name="uploadform">
          <p class="text-center text-sm">{{scromFileName || 'No File Selected'}}</p>
          <button (click)="Scormfiles.click()" type="button" id="filesLabel" class="btn m-auto">Select
            File</button>
          <input #Scormfiles (change)="scromFileName = Scormfiles.files[0]?.name" type="file" name="Scormfiles"
            accept=".zip" aria-labelledby="filesLabel" id="classfile" class="sr-only" required>
          <div class="d-flex justify-content-around flex-wrap gap-1.5 mt-5">
            <button type="submit" class="btn m-0" [disabled]="Scormfiles.files.length < 1">Upload</button>
            <button type="button" class="btn btn--warning m-0" data-dismiss="modal" aria-label="Close">Close</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" #welcometextfrominvitemail id="welcometextfrominvitemail" aria-hidden="true" aria-labelledby="welcometextfrominvitemail" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      
      <div class="d-flex align-items-center w-100 p-3">      
        <h1 class="modal-title flex-grow-1 text-center m-0" style="font-size: xx-large;">
          {{ moduleInfo.price > 0 ? ('Complete your enrolment in ' + moduleInfo.name) : ('You are enrolled in ' + moduleInfo.name ) }}
        </h1>
      
        <!-- <button type="button" class="close ms-auto" data-dismiss="modal" aria-label="Close" style="font-size: x-large;">
          <span aria-hidden="true">&times;</span>
        </button> -->
      </div>
      <div class="modal-body">
        <div class="success-icon text-center">
          <i class="fa fa-check-circle"></i>
        </div>
        <p class="start-date text-center">
          <ng-container *ngIf="moduleInfo.startDate; else noDate">
            It starts on {{ moduleInfo.startDate | date:'EEEE, MMM d, y' }}
          </ng-container>
          <ng-template #noDate>
            Available now — start any time.
          </ng-template>
        </p>
        <button class="btn btn-primary go-btn mt-5" data-dismiss="modal" (click)="payFromModalPopUp()">
          {{ moduleInfo.price > 0 ? ('Pay ₦' + moduleInfo.price + 'to enroll') : 'Go to my course' }}
        </button>
      </div>
    </div>
  </div>
</div>